import {createSelector} from '@ngrx/store';

import {IAppState} from '@app/core/store/state/app.state';
import {IShiftDraftsState} from '@app/core/store/state/shift-drafts.state';

const _selectShiftDrafts = (state: IAppState) => state.shiftDrafts;

export const selectIsLoadingShiftDrafts = createSelector(
	_selectShiftDrafts,
	(state: IShiftDraftsState) => state.isLoading,
);

export const selectSelectedShiftDraft = createSelector(
	_selectShiftDrafts,
	(state: IShiftDraftsState) => state.selectedShiftDraft,
);

export const selectShiftDrafts = createSelector(
	_selectShiftDrafts,
	(state: IShiftDraftsState) => state.shiftDrafts,
);
export const selectIsReleasingDraft = createSelector(
	_selectShiftDrafts,
	(state: IShiftDraftsState) => state.isReleasingDraft,
);

